import React from 'react';
import branding from '@/config/branding';

/**
 * Context size presets (always contain, never stretch or distort)
 */
const CONTEXT_STYLES = {
  header: 'h-9 sm:h-10 md:h-11 max-w-[220px] sm:max-w-[260px]',
  sidebar: 'h-10 max-w-[180px]',
  sidebarCollapsed: 'h-9 w-9 max-w-[36px]',
  auth: 'h-14 sm:h-16 md:h-20 max-w-[300px]',
  footer: 'h-10 sm:h-12 max-w-[240px]',
  loading: 'h-16 sm:h-20 max-w-[280px]',
  dashboard: 'h-9 sm:h-10 max-w-[200px]',
  mobile: 'h-8 max-w-[160px]',
  default: 'h-10 max-w-[220px]'
};

export const BrandLogo = ({
  context = 'default',
  className = '',
  imgClassName = '',
  alt = branding.name,
  src = branding.logo,
  animate = true,
  onClick,
  showTagline = false,
  ...props
}) => {
  if (context === 'sidebarCrest') {
    return (
      <div 
        className={`flex flex-col items-center justify-center text-center select-none py-2 ${animate ? 'animate-logo-reveal' : ''} ${className}`}
        onClick={onClick}
        {...props}
      >
        <img
          src={src}
          alt={alt}
          className="h-14 sm:h-16 w-auto object-contain transition-transform duration-300 hover:scale-[1.03]"
          loading="eager"
          decoding="async"
          onError={(e) => {
            if (e.currentTarget.src !== branding.logoSvg) {
              e.currentTarget.src = branding.logoSvg;
            }
          }}
        />
        <div className="mt-2.5 space-y-0.5">
          <h2 className="text-sm font-bold tracking-[0.25em] text-[#C9A227] font-serif uppercase">
            BND HOLDING
          </h2>
          <p className="text-[10px] italic font-serif text-[#C9A227]/90 pt-1 tracking-wide">
            {branding.tagline}
          </p>
        </div>
      </div>
    );
  }

  const sizeClass = CONTEXT_STYLES[context] || CONTEXT_STYLES.default;

  return (
    <div 
      className={`inline-flex items-center justify-center select-none ${animate ? 'animate-logo-reveal' : ''} ${className}`}
      onClick={onClick}
      {...props}
    >
      <img
        src={src}
        alt={alt}
        className={`w-auto object-contain transition-transform duration-300 hover:scale-[1.02] ${sizeClass} ${imgClassName}`}
        loading="eager"
        decoding="async"
        onError={(e) => {
          if (e.currentTarget.src !== branding.logoSvg) {
            e.currentTarget.src = branding.logoSvg;
          }
        }}
      />
    </div>
  );
};

export default BrandLogo;
